// TEMPORARY: preview page for the shared MyWork view.
// Remove this file and the /work-queue-preview route in app.tsx once the view is wired into the extension.
import { CtyShowToast, MyWork, checkType } from '@circuitry-ai/doc-ui';

export function WorkQueuePreview() {
  return (
    <div className="flex py-3 h-full min-h-0">
      {/* Full content width; MyWork adapts its own layout from one column (side panel) to a grid */}
      <div className="flex flex-col w-full h-[calc(100vh-140px)] rounded-xl border border-default-200 shadow-lg overflow-hidden">
        <div className="flex items-center gap-3 px-3 py-[13px] bg-primary text-primary-foreground text-[15px] font-semibold">
          My Work
        </div>
        <MyWork
          onCreate={(option) => CtyShowToast(checkType.info, `Create ${option.label} clicked`)}
          onEdit={(item) => CtyShowToast(checkType.info, `Edit #${item.source?.number ?? item.id}`)}
          onView={(item) => CtyShowToast(checkType.info, `View #${item.source?.number ?? item.id}`)}
          // The preview has no reminder delivery; MyWork records the reminder in the item's history
          onManualAction={async () => undefined}
        />
      </div>
    </div>
  );
}

export default WorkQueuePreview;
